export const truncateText = (text: string) => {
  const maxLength = 125
  return text.length > maxLength ? text.slice(0, maxLength - 1) + '...' : text
}

/**
 * Strips non-breaking spaces (&nbsp; entities and \u00A0 characters)
 * and other invisible Unicode characters from a string.
 * Used to sanitize HTML content from TinyMCE before rendering.
 */
export const stripInvisibleChars = (value: string | undefined | null): string => {
  if (!value) return ''
  return value
    .replace(/&nbsp;/g, ' ')
    .replace(/\u00A0/g, ' ')
    .replace(/\u200B/g, '')
    .replace(/\u200C/g, '')
    .replace(/\u200D/g, '')
    .replace(/\u2060/g, '')
    .replace(/\uFEFF/g, '')
}
